module.exports = __webpack_public_path__ + "img/logo_cctv.625e9a37.png";